import Star from '@mui/icons-material/Star';
import Typography from '@mui/material/Typography';
import Grid from '@shared/components/Grid';
import { H2 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { TESTIMONIALS } from '../../assets/data/testimonials';
import { SectionGold } from '../../components/ColoredSection';
import { TestimonialType } from '../../types/testimonials';
import { COLOR } from '../../types/theme';
import { colorToCss } from '../../utils/theme';

const Testi: FC = () => (
  <SectionGold>
    <H2>Begeisterte Teilnehmer</H2>

    <Grid columns={{ lg: 3, md: 2, xs: 1 }} spacing={{ lg: '2rem', md: '1.5rem', xs: '1rem' }}>
      {TESTIMONIALS.filter(({ types }) => types.includes(TestimonialType.Kampfkunst)).map(
        ({ name, text }, index) => (
          <Grid.Centered
            key={index}
            sx={{
              background: colorToCss(COLOR.White),
              borderRadius: '1rem',
              minHeight: { lg: '260px' },
              padding: { md: '0.75em', xs: '0.5em' },
            }}
          >
            {Array.from({ length: 5 }).map((_v, index) => (
              <Star key={index} sx={{ color: colorToCss(COLOR.Gold1) }} />
            ))}

            <Typography
              component='blockquote'
              sx={{ color: colorToCss(COLOR.Black), marginBottom: '0.5rem' }}
            >
              {text}
            </Typography>

            <Paragraph color={COLOR.Gray2} variant='body2'>
              {name}
            </Paragraph>
          </Grid.Centered>
        )
      )}
    </Grid>
  </SectionGold>
);

export default memo(Testi);
